import { render, staticRenderFns } from "./position.vue?vue&type=template&id=035e0cd1&scoped=true&lang=pug&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&id=035e0cd1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e0cd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('035e0cd1', component.options)
    } else {
      api.reload('035e0cd1', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=035e0cd1&scoped=true&lang=pug&", function () {
      api.rerender('035e0cd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/position/position.vue"
export default component.exports